import { createAction } from '@wix/communities-blog-client-common';

export const TAG_CLICKED = 'tag/CLICKED';

export const tagClicked = createAction(TAG_CLICKED);
